// extracted by mini-css-extract-plugin
module.exports = {"EducationObserver":"education-observer_EducationObserver__5MCj5"};